import { render, staticRenderFns } from "./PatientAgeFilters.vue?vue&type=template&id=0dd03440&"
import script from "./PatientAgeFilters.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PatientAgeFilters.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd03440')) {
      api.createRecord('0dd03440', component.options)
    } else {
      api.reload('0dd03440', component.options)
    }
    module.hot.accept("./PatientAgeFilters.vue?vue&type=template&id=0dd03440&", function () {
      api.rerender('0dd03440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/vue_components/common/TheFilters/doctors/components/PatientAgeFilters/PatientAgeFilters.vue"
export default component.exports